module.exports = __webpack_public_path__ + "../resources/img/checkbox_selected.3d56be75.svg";